import { useTranslation } from "react-i18next";
import { X } from "lucide-react";
import { useHolidayTheme } from "@/hooks/useHolidayTheme";
import { Button } from "@/components/ui/button";

/** Staff-only chip so a private theme preview is obvious and easy to exit. */
export function HolidayPreviewChip() {
  const { t } = useTranslation();
  const { isPreview, preview, clearPreview } = useHolidayTheme();

  if (!isPreview || !preview) return null;

  const label =
    preview === "christmas"
      ? t("holidayHub.previewChristmas", { defaultValue: "Christmas preview" })
      : preview === "new_year"
        ? t("holidayHub.previewNewYear", { defaultValue: "New Year preview" })
        : preview === "valentine"
          ? t("holidayHub.previewValentine", { defaultValue: "Valentine preview" })
          : preview === "halloween"
            ? t("holidayHub.previewHalloween", { defaultValue: "Halloween preview" })
            : t("holidayHub.previewOff", { defaultValue: "Holiday theme off" });

  return (
    <div className="fixed bottom-20 md:bottom-4 left-1/2 -translate-x-1/2 z-[60] flex items-center gap-2 rounded-full border border-border bg-card/95 px-3 py-1.5 shadow-lg backdrop-blur-sm">
      <span className="text-xs font-medium">{label}</span>
      <span className="text-[10px] text-muted-foreground hidden sm:inline">
        {t("holidayHub.previewHint", { defaultValue: "Only you — this tab" })}
      </span>
      <Button size="sm" variant="ghost" className="h-6 w-6 p-0" onClick={clearPreview}>
        <X className="w-3.5 h-3.5" />
      </Button>
    </div>
  );
}
